<div class="name-grid" [formGroup]="nameForm">
  <!-- Last name -->
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.LAST_NAME' | translate}}*</h1>
    <div class="input-box">
      <input
        [ngStyle]="{'border': (submitted && firstNameControl?.hasError('required')) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        autocomplete="off"
        formControlName="first_name"
        placeholder="{{ 'FORM.PLACEHOLDER.LAST_NAME' | translate}}"
      />
    </div>
    <span
      *ngIf="submitted && firstNameControl?.hasError('required')"
      class="error-message"
    >
      {{'FORM.VALID.NAME_VALID' | translate}}
    </span>
  </div>

  <!-- First name -->
  <div class="input-form-box">
    <h1 class="label">{{ 'FORM.LABELS.FIRST_NAME' | translate}}*</h1>
    <div class="input-box">
      <input
        [ngStyle]="{'border': (submitted && lastNameControl?.hasError('required')) ? '1px rgba(152, 26, 48, 1) solid' : '1px white solid'}"
        autocomplete="off"
        formControlName="last_name"
        placeholder="{{ 'FORM.PLACEHOLDER.FIRST_NAME' | translate}}"
      />
    </div>
    <span
      *ngIf="submitted && lastNameControl?.hasError('required')"
      class="error-message"
    >
      {{'FORM.VALID.LASTNAME_VALID' | translate}}
    </span>
  </div>
</div>
